/* ===== fudge01: tabio.js ===== */

jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.migi').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('migix');
		}
	  });
	});
});


jQuery(function () {
	var timer = 1400;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer1 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 1100;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer2 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 1200;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer3 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 900;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer4 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 1200;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer5 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 1200;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer6 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 3000;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer7 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});


jQuery(function () {
	var timer = 3000;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer8 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});

jQuery(function () {
	var timer = 1400;
	// スライドする要素を取得
	var imgs = document.querySelectorAll('#viewer9 img');
	// 最初の画像を表示
	imgs[0].classList.add('show');
	// 画像の番号
	var imgNum = 0;
	function showImg() {
		for (var i = 0; i < imgs.length; i++) {
			imgs[i].classList.remove('show');
		}
		if (imgNum >= imgs.length - 1) {
			imgNum = 0;
		} else {
			imgNum++;
		}
		imgs[imgNum].classList.add('show');
		showImgTimer();
	}
	function showImgTimer() {
		setTimeout(showImg, timer);
	}
	showImgTimer()

});



jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.hidari').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('hidarix');
		}
	  });
	});
});

jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.sita').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('sitax');
		}
	  });
	});
});


jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.ue').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('uex');
		}
	  });
	});
});


jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.out').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('outx');
		}
	  });
	});
});


jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.circle').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('circlex');
		}
	  });
	});
});


jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.flip').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('flipx');
		}
	  });
	});
});

jQuery(function () {
	jQuery(window).scroll(function () {
	  jQuery('.fade').each(function () {
		var targetElement = jQuery(this).offset().top;
		var scroll = jQuery(window).scrollTop();
		var windowHeight = jQuery(window).height();
		if (scroll > targetElement - windowHeight + 50) {

		  jQuery(this).addClass('fadex');
		}
	  });
	});
});




jQuery(function() {
	jQuery('html,body').animate({ scrollTop: 0 }, '1');
});


;
/* ===== fudge01: inline script #1 ===== */
(function(d) {
		  var config = {
			kitId: 'ojg6imc',
			scriptTimeout: 3000,
			async: true
		  },
		  h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
		})(document);

;
/* ===== fudge01: inline script #2 ===== */
const targets = document.querySelectorAll(
		'.sc1, .sc1a, .sc1b, .con1, .con2, .con3, .con4, .con5, .con6'
	);

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
			} else {
				entry.target.classList.remove('active');
			}
		});
	}, {
		threshold: 0.2
	});

	targets.forEach(el => observer.observe(el));
